module.exports = __webpack_public_path__ + "static/img/yaluanwan.dabb648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yaluanwan.jpg
// module id = Om0U
// module chunks = 52